export interface OrderLevelFeeDisclaimerConfig {
  isOrderLevelFeeDisclaimerDisplayed: boolean;
  orderLevelFeeDisclaimerText: string;
}

export default function render(config: OrderLevelFeeDisclaimerConfig) {
  if (!config.isOrderLevelFeeDisclaimerDisplayed || !config.orderLevelFeeDisclaimerText) {
    return '';
  }

  return `<div class="tn-syos__order-level-fee-disclaimer-container">
            <div class="tn-order-level-fee-disclaimer">${config.orderLevelFeeDisclaimerText}</div>
          </div>`;
}
